import { odataAxios, merchantAxios } from '.'

export const getOrgUserByUserId = async (token, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await odataAxios.get(
        `/OrgUser?$filter=UserID eq '${params.userId}' and LastOrgId eq OrgId&$expand=Organization`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      resolve(response.data.value)
    } catch (error) {
      reject(error)
    }
  })
}

export const getOrgNameByOrgId = async (token, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await odataAxios.get(
        `/Organization?$select=OrgName, OrgCurrency&$filter=OrgId eq ${params.orgId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      resolve(response.data.value)
    } catch (error) {
      reject(error)
    }
  })
}

export const getDefaultCompanyProfile = (token) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await odataAxios.get(
        '/CompanyProfile?filter=IsDeleted eq false and IsDefault eq true',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      resolve(response.data.value)
    } catch (error) {
      reject(error)
    }
  })
}


export const getCountryNameById = async (token, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await odataAxios.get(
        `/Country?$filter=CountryId eq ${params.countryId} &$select=CountryDesc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      resolve(response.data.value)
    } catch (error) {
      reject(error)
    }
  })
}